import { render } from "./IngressEgressRuleConfigure.vue?vue&type=template&id=54d3272f&scoped=true"
import script from "./IngressEgressRuleConfigure.vue?vue&type=script&lang=js"
export * from "./IngressEgressRuleConfigure.vue?vue&type=script&lang=js"

import "./IngressEgressRuleConfigure.vue?vue&type=style&index=0&id=54d3272f&scoped=true&lang=scss"

import exportComponent from "/home/vinicius.valle/projetos/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d3272f"]])

export default __exports__